/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerAccountDeletionTaskStatsForPeriod } from './';
import {
    FreelancerAccountDeletionTaskStatsForPeriodFromJSON,
    FreelancerAccountDeletionTaskStatsForPeriodFromJSONTyped,
    FreelancerAccountDeletionTaskStatsForPeriodToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerAccountDeletionTaskStats
 */
export interface FreelancerAccountDeletionTaskStats {
    /**
     * 
     * @type {FreelancerAccountDeletionTaskStatsForPeriod}
     * @memberof FreelancerAccountDeletionTaskStats
     */
    currentMonth: FreelancerAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {FreelancerAccountDeletionTaskStatsForPeriod}
     * @memberof FreelancerAccountDeletionTaskStats
     */
    currentWeek: FreelancerAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {FreelancerAccountDeletionTaskStatsForPeriod}
     * @memberof FreelancerAccountDeletionTaskStats
     */
    over3Months: FreelancerAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {FreelancerAccountDeletionTaskStatsForPeriod}
     * @memberof FreelancerAccountDeletionTaskStats
     */
    pastMonth: FreelancerAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {FreelancerAccountDeletionTaskStatsForPeriod}
     * @memberof FreelancerAccountDeletionTaskStats
     */
    pastPastMonth: FreelancerAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {FreelancerAccountDeletionTaskStatsForPeriod}
     * @memberof FreelancerAccountDeletionTaskStats
     */
    pastWeek: FreelancerAccountDeletionTaskStatsForPeriod;
    /**
     * 
     * @type {FreelancerAccountDeletionTaskStatsForPeriod}
     * @memberof FreelancerAccountDeletionTaskStats
     */
    sinceTheBeginning: FreelancerAccountDeletionTaskStatsForPeriod;
}

/**
 * Check if a given object implements the FreelancerAccountDeletionTaskStats interface.
 */
export function instanceOfFreelancerAccountDeletionTaskStats(value: object): value is FreelancerAccountDeletionTaskStats {
    if (!('currentMonth' in value) || value['currentMonth'] === undefined) return false;
    if (!('currentWeek' in value) || value['currentWeek'] === undefined) return false;
    if (!('over3Months' in value) || value['over3Months'] === undefined) return false;
    if (!('pastMonth' in value) || value['pastMonth'] === undefined) return false;
    if (!('pastPastMonth' in value) || value['pastPastMonth'] === undefined) return false;
    if (!('pastWeek' in value) || value['pastWeek'] === undefined) return false;
    if (!('sinceTheBeginning' in value) || value['sinceTheBeginning'] === undefined) return false;
    return true;
}

export function FreelancerAccountDeletionTaskStatsFromJSON(json: any): FreelancerAccountDeletionTaskStats {
    return FreelancerAccountDeletionTaskStatsFromJSONTyped(json, false);
}

export function FreelancerAccountDeletionTaskStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerAccountDeletionTaskStats {
    if (json == null) {
        return json;
    }
    return {
        
        'currentMonth': FreelancerAccountDeletionTaskStatsForPeriodFromJSON(json['currentMonth']),
        'currentWeek': FreelancerAccountDeletionTaskStatsForPeriodFromJSON(json['currentWeek']),
        'over3Months': FreelancerAccountDeletionTaskStatsForPeriodFromJSON(json['over3Months']),
        'pastMonth': FreelancerAccountDeletionTaskStatsForPeriodFromJSON(json['pastMonth']),
        'pastPastMonth': FreelancerAccountDeletionTaskStatsForPeriodFromJSON(json['pastPastMonth']),
        'pastWeek': FreelancerAccountDeletionTaskStatsForPeriodFromJSON(json['pastWeek']),
        'sinceTheBeginning': FreelancerAccountDeletionTaskStatsForPeriodFromJSON(json['sinceTheBeginning']),
    };
}

export function FreelancerAccountDeletionTaskStatsToJSON(value?: FreelancerAccountDeletionTaskStats | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentMonth': FreelancerAccountDeletionTaskStatsForPeriodToJSON(value['currentMonth']),
        'currentWeek': FreelancerAccountDeletionTaskStatsForPeriodToJSON(value['currentWeek']),
        'over3Months': FreelancerAccountDeletionTaskStatsForPeriodToJSON(value['over3Months']),
        'pastMonth': FreelancerAccountDeletionTaskStatsForPeriodToJSON(value['pastMonth']),
        'pastPastMonth': FreelancerAccountDeletionTaskStatsForPeriodToJSON(value['pastPastMonth']),
        'pastWeek': FreelancerAccountDeletionTaskStatsForPeriodToJSON(value['pastWeek']),
        'sinceTheBeginning': FreelancerAccountDeletionTaskStatsForPeriodToJSON(value['sinceTheBeginning']),
    };
}

